import { LoadableLazy } from '@confluence/loadable';

export { NAV_4_ONBOARDING_ENGAGEMENT_PLATFORM_MESSAGE_KEY } from './Nav4OnboardingModal';
export { NAV_4_CHANGEBOARDING_ENGAGEMENT_PLATFORM_MESSAGE_KEY } from './Nav4ChangeboardingSpotlight';

export const Nav4OnboardingModalLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4OnboardingModal" */ './Nav4OnboardingModal'))
			.Nav4OnboardingModal,
});

export const Nav4ChangeboardingSpotlightLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-Nav4ChangeboardingSpotlight" */ './Nav4ChangeboardingSpotlight'
			)
		).Nav4ChangeboardingSpotlight,
});
